import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'
import type { SchemaOwner } from '@cli-types/preset-engine/presets.js'
import { getSchemaOwner } from '@preset-engine/ownership/get-schema-owner.js'
import { collectRelationshipTargets } from './collect-relationship-targets.js'
import { presetIdFromOwner } from './preset-id-from-owner.js'

export function collectRelationshipTargetWarnings(
  cwd: string,
  owner: SchemaOwner,
  field: GeneratedSchemaField
): string[] {
  if (owner !== 'user') {
    return []
  }

  const targetNames = new Set<string>()
  collectRelationshipTargets(field, targetNames)

  return Array.from(targetNames)
    .map((targetName) => {
      const targetOwner = getSchemaOwner(cwd, targetName)
      const presetId = targetOwner ? presetIdFromOwner(targetOwner) : null
      return presetId
        ? `This user-owned schema references preset-owned schema "${targetName}". Removing preset "${presetId}" may affect that relationship.`
        : null
    })
    .filter((warning): warning is string => Boolean(warning))
}
